import { authorizedAxiosInstance } from '../../common/api/instances/AuthorizedAxiosInstance';

export const getCustomerGroup = async (customerGroupId: string) => {
    return authorizedAxiosInstance.get(`/v1/customergroup/${customerGroupId}`).then((response) => response.data);
};

export const getCustomerCompanies = async () => {
    return authorizedAxiosInstance.get(`/v1/customer/list`).then((response) => response.data);
};
